<template>
    <div :class="fullInformation ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-6'" v-if="model">
        <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow">
            <div class="team-member" :class="fullInformation ? 'full-info' : 'name-only'">
                <div class="image" v-if="fullInformation">
                    <SmartLinkStandaloneElement :codename="type.elements.image.codename">      
                        <div v-if="model.elements.image.value.length > 0" class="ratio ratio-16x9">
                            <NuxtImg v-for="img in model.elements.image.value" :src="img.url" class="object-fit-cover" />       
                        </div>                                   
                        <div v-else class="ratio ratio-16x9 bg-pale-blue"></div>
                    </SmartLinkStandaloneElement>
                </div>
                <div class="name">
                    <SmartLinkStandaloneElement :codename="type.elements.name.codename">
                        <h3>{{ model.elements.name.value }}</h3>
                    </SmartLinkStandaloneElement>
                </div>
                <div class="linkedin" v-if="fullInformation">
                    <SmartLinkStandaloneElement :codename="type.elements.linkedin.codename">
                        <NuxtLink :to="model.elements.linkedin.value">LinkedIn</NuxtLink>
                    </SmartLinkStandaloneElement>
                </div>
                <div class="member-description">
                    <SmartLinkStandaloneElement :codename="type.elements.description.codename">
                        <RichText v-if="!isEmpty(model.elements.description.value)" :value="model.elements.description.value"/>
                    </SmartLinkStandaloneElement>
                </div>
            </div>        
        </SmartLinkItemComponent>
    </div>
</template>

<script lang="ts" setup>
import { contentTypes, type TeamMemberModel } from '~~/app/models';
const type = contentTypes.team_member;
const props = defineProps<{model:TeamMemberModel, fullInformation:boolean}>();
</script>